import { MobileRoute } from 'resources/routes'
import { isDeviceMobile } from './mobile'

// Auto Login Redirect
export function autoLoginRedirect(
  navigate,
  pathname,
  doMobileCheck = true,
  mobilePathname = MobileRoute
) {
  if (doMobileCheck && isDeviceMobile()) {
    navigate(mobilePathname)
  } else if (pathname) {
    window.location.replace(pathname)
  }
}
